<template>

	<div>

		<el-row class="mb-3">
			<p class="mb-1 comfy-text">Elige fecha y hora para tu reserva:</p>
		</el-row>

		<el-row class="mb-3" :gutter="10">

			<el-col :span="12">
				<el-date-picker
					v-model="servicio.fecha"
					type="date"
					:picker-options="pickerOptions"
					value-format="yyyy-MM-dd"
					placeholder="Elige el día"
					@change="changeDate">
				</el-date-picker>
			</el-col>

			<el-col :span="12" v-show="servicio.fecha">
				<el-time-select
					placeholder="Elige la hora"
					v-model="servicio.hora"
					:picker-options="pickerOptions"
					:disabled="disabledTime">
				</el-time-select>
			</el-col>

		</el-row>

		<el-row class="mb-3" v-show="servicio.hora">

			<el-col :span="24">

				<p class="mb-1 comfy-text">Elige la duración de tu servicio:</p>

				<el-radio-group v-model="servicio.duracion" class="w-100">
					<el-radio-button label="60" class="w-33">
						<p class="font-weight-bold comfy-second-text mb-0 s-36 ivy-bold">60<span class="d-block grey-text s-10 font-weight-normal">Minutos</span></p>
					</el-radio-button>
					<el-radio-button label="90" v-if="servicio.tipo != 'btb'" class="w-33">
						<p class="font-weight-bold comfy-second-text mb-0 s-36 ivy-bold">90<span class="d-block grey-text s-10 font-weight-normal">Minutos</span></p>
					</el-radio-button>
					<el-radio-button label="120" v-if="servicio.tipo != 'btb'" class="w-33">
						<p class="font-weight-bold comfy-second-text mb-0 s-36 ivy-bold">120<span class="d-block grey-text s-10 font-weight-normal">Minutos</span></p>
					</el-radio-button>
				</el-radio-group>

			</el-col>

		</el-row>

		<el-row class="mb-3" v-if="servicio.tipo == 'doble' && servicio.duracion">

			<el-col :span="24">

				<p class="mb-1 comfy-text">Para cuántas personas deseas tu masaje grupal:</p>

				<el-radio-group v-model="servicio.grupal" class="w-100">
					<el-radio-button label="2" class="w-25">
						<p class="font-weight-bold comfy-second-text mb-0 s-36">2<span class="d-block grey-text s-10 font-weight-normal">Personas</span></p>
					</el-radio-button>
					<el-radio-button label="3" v-if="servicio.tipo != 'btb'" class="w-25">
						<p class="font-weight-bold comfy-second-text mb-0 s-36">3<span class="d-block grey-text s-10 font-weight-normal">Personas</span></p>
					</el-radio-button>
					<el-radio-button label="4" v-if="servicio.tipo != 'btb'" class="w-25">
						<p class="font-weight-bold comfy-second-text mb-0 s-36">4<span class="d-block grey-text s-10 font-weight-normal">Personas</span></p>
					</el-radio-button>
					<el-radio-button label="5" v-if="servicio.tipo != 'btb'" class="w-25">
						<p class="font-weight-bold comfy-second-text mb-0 s-36">5<span class="d-block grey-text s-10 font-weight-normal">Personas</span></p>
					</el-radio-button>
				</el-radio-group>

			</el-col>

		</el-row>

		<el-row class="mb-3" v-show="servicio.duracion">

			<el-col :span="24">

				<p class="mb-1 comfy-text">Elige el masaje de tu preferencia:</p>

				<el-select v-model="servicio.masaje_uno" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
					<el-option
						v-for="item in masajes"
						:key="item.id"
						:label="item.nombre"
						:value="item.id">
					</el-option>
				</el-select>

			</el-col>

			<el-col class="mt-3" :span="24" v-if="servicio.tipo == 'doble' || servicio.tipo == 'btb'">

				<el-select v-model="servicio.masaje_dos" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
					<el-option
						v-for="item in masajes"
						:key="item.id"
						:label="item.nombre"
						:value="item.id">
					</el-option>
				</el-select>

			</el-col>

			<el-col class="mt-3" :span="24" v-if="servicio.tipo == 'doble' && servicio.grupal > 2">

				<el-select v-model="servicio.masaje_tres" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
					<el-option
						v-for="item in masajes"
						:key="item.id"
						:label="item.nombre"
						:value="item.id">
					</el-option>
				</el-select>

			</el-col>

			<el-col class="mt-3" :span="24" v-if="servicio.tipo == 'doble' && servicio.grupal > 3">

				<el-select v-model="servicio.masaje_cuatro" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
					<el-option
						v-for="item in masajes"
						:key="item.id"
						:label="item.nombre"
						:value="item.id">
					</el-option>
				</el-select>

			</el-col>

			<el-col class="mt-3" :span="24" v-if="servicio.tipo == 'doble' && servicio.grupal > 4">

				<el-select v-model="servicio.masaje_cinco" clearable placeholder="Selecciona tu masaje" size="large" class="w-100">
					<el-option
						v-for="item in masajes"
						:key="item.id"
						:label="item.nombre"
						:value="item.id">
					</el-option>
				</el-select>

			</el-col>

		</el-row>

		<el-row class="mb-3" v-if="error">
			<el-col :span="24">
				<div class="font-weight-normal text-danger">
					<p>
						<span v-text="errores"></span> <a v-if="buttonurl" class="text-success text-decoration-underline" target="_blank" :href="buttonurl" v-text="textbutton"></a>
					</p>
				</div>
			</el-col>
		</el-row>

	</div>

</template>

<style type="text/css">
	.el-date-editor.el-input, .el-date-editor.el-input__inner{
		width: 100%;
	}
	.el-radio-button.w-25 {
		width: 24.66666% !important;
	}
	.el-radio-button.w-25 .el-radio-button__inner, .el-radio-button.w-49 .el-radio-button__inner {
		width: 100%;
	}
	.el-radio-button.w-25.is-active .el-radio-button__inner p, .el-radio-button.w-25.is-active .el-radio-button__inner p span{
		color:  white !important;
	}
</style>

<script>
	import moment from 'moment'

	export default {
		props: [
			'servicio'
		],
		data() {
			return {
				pickerOptions: {
					disabledDate: this.disabledDate,
					start: '06:00',
					step: '00:30',
					end: '22:00',
					minTime: '05:30'
				},
				masajes: [],
				error: false,
				errores: '',
				textbutton: '',
				buttonurl: '',
				disabledTime: false,
				confirmarProceso: false
			}
		},
		watch: {
			'servicio.fecha': function(val){
				this.minTime(val)
				// this.validarDatosSolicitud()
			},
			'servicio.hora': function(val){
				if(!this.servicio.hora){
					this.servicio.duracion = ''
					return
				}
				this.checkTodayTime(val)
				this.validarDatosSolicitud()
			},
			'servicio.grupal': function(val){
				this.getMassages()
				if(this.servicio.grupal == '2'){
					this.servicio.masaje_tres = ''
					this.servicio.masaje_cuatro = ''
					this.servicio.masaje_cinco = ''
				}
				if(this.servicio.grupal == '3'){
					this.servicio.masaje_cuatro = ''
					this.servicio.masaje_cinco = ''
				}
				if(this.servicio.grupal == '4'){
					this.servicio.masaje_cinco = ''
				}
				this.validarDatosSolicitud()
			},
			'servicio.masaje_uno': function(val){
				this.validarDatosSolicitud()
			},
			'servicio.masaje_dos': function(val){
				this.servicio.masaje_tres = ''
				this.servicio.masaje_cuatro = ''
				this.servicio.masaje_cinco = ''
				this.validarDatosSolicitud()
			},
			'servicio.masaje_tres': function(val){
				this.servicio.masaje_cuatro = ''
				this.servicio.masaje_cinco = ''
				this.validarDatosSolicitud()
			},
			'servicio.masaje_cuatro': function(val){
				this.servicio.masaje_cinco = ''
				this.validarDatosSolicitud()
			},
			'servicio.masaje_cinco': function(val){
				this.validarDatosSolicitud()
			},
			'servicio.duracion': function(val){
				if(!this.servicio.duracion){
					this.servicio.masaje_uno = '',
					this.servicio.masaje_dos = '',
					this.servicio.masaje_tres = '',
					this.servicio.masaje_cuatro = '',
					this.servicio.masaje_cinco = ''
				}
				this.validarDatosSolicitud()
			},
			'confirmarProceso': function(val){
				EventBus.$emit('confirmarPasoDosFecha', val)
			}
		},
		methods: {
            irInicio(){
                EventBus.$emit('limpiarPasoDos')
                this.servicio.step = this.servicio.step - 1
                this.servicio.busqueda = "masajista"
            },
			disabledDate(time){
				const days = 60 * 24 * 3600 * 1000
				return time.getTime() < moment().subtract(1, 'days') || time.getTime() > Date.now() + days
			},
			minTime(date){
				var today = moment().format('YYYY-MM-DD')
				if(date == today){
					this.disabledTime = false
					this.pickerOptions.minTime = moment().add(2, 'hours').format('H:mm')
					if(moment().format('HH:mm') > '22:00'){
						this.disabledTime = true
						return
					}
				}else{
					this.disabledTime = false
					this.pickerOptions.minTime = '05:30'
				}
			},
			checkTodayTime(time){
				var today = moment().format('YYYY-MM-DD')
				var date = this.servicio.fecha
				var minTime = moment().add(2, 'hours').format('HH:mm') // format('H:mm')
				// console.log(today, date, minTime, time)
				if(date == today){
					if(minTime > time){
						this.servicio.hora = ''
						return
					}
				}
			},
			changeDate(){
				this.servicio.hora = ''
				this.servicio.duracion = ''
				var url = '/get-massages'
				if(this.servicio.grupal == 2 && this.servicio.tipo == 'doble'){
					url = '/get-massages?cantidad=' + this.servicio.grupal
				}
				axios.get(url).then(response => {
					// console.log(response.data)
					this.masajes = response.data.massages
				}).catch(error => {
					console.log(error)
				})
			},
			getMassages(){
				var url = '/get-massages'
				if(this.servicio.grupal == 2 && this.servicio.tipo == 'doble'){
					url = '/get-massages?cantidad=' + this.servicio.grupal
				}
				axios.get(url).then(response => {
					this.masajes = response.data.massages
				}).catch(error => {
					console.log(error)
				})
			},
			validarDatosSolicitud(){
				this.confirmarProceso = false
				this.error = false
				this.errores = ''
				this.textbutton = ''
				this.buttonurl = ''
				this.servicio.precio = ''
				if(!this.servicio.fecha){
					return
				}
				if(!this.servicio.hora){
					return
				}
				if(!this.servicio.duracion){
					return
				}
				if(!this.servicio.masaje_uno){
					return
				}
				if(this.servicio.tipo != 'sencillo'){
					if(!this.servicio.masaje_dos){
						return
					}
				}
				if(this.servicio.grupal > 2){
					if(!this.servicio.masaje_tres){
						return
					}
				}
				if(this.servicio.grupal > 3){
					if(!this.servicio.masaje_cuatro){
						return
					}
				}
				if(this.servicio.grupal > 4){
					if(!this.servicio.masaje_cinco){
						return
					}
				}
                this.servicio.tarifaDinamica = 0
				this.servicio.terapistaUno = ''
				this.servicio.masajeUnoValor = 0
                this.servicio.tarifaDinamicaUno = 0
				this.servicio.terapistaDos = ''
				this.servicio.masajeDosValor = 0
                this.servicio.tarifaDinamicDos = 0
				this.servicio.terapistaTres = ''
				this.servicio.masajeTresValor = 0
                this.servicio.tarifaDinamicaTres = 0
				this.servicio.terapistaCuatro = ''
				this.servicio.masajeCuatroValor = 0
                this.servicio.tarifaDinamicaCuatro = 0
				this.servicio.terapistaCinco = ''
				this.servicio.masajeCincoValor = 0
                this.servicio.tarifaDinamicaCinco = 0
				var url = '/cliente/servicio/buscar-fecha'
				axios.post(url, {
					'city_id': this.servicio.ciudad,
					'tipo': this.servicio.tipo,
					'masaje_uno': this.servicio.masaje_uno,
					'masaje_dos': this.servicio.masaje_dos,
					'masaje_tres': this.servicio.masaje_tres,
					'masaje_cuatro': this.servicio.masaje_cuatro,
					'masaje_cinco': this.servicio.masaje_cinco,
					'duracion': this.servicio.duracion,
					'direccion': this.servicio.datosDireccion.direccion,
					'fecha': this.servicio.fecha,
					'hora': this.servicio.hora,
					'duplicidad': 0,
					'grupal': this.servicio.grupal,
					'genero': this.servicio.genero,
				}).then(response => {
					// console.log(response.data.code)
					// console.log(response.data.terapistasIds)
					// console.log(response.data.globalTerapistas)
					if(response.data.code == '400'){
						this.error = true
						this.errores = response.data.error
						this.servicio.precio = ''
						if(response.data.textbutton){
							this.textbutton = response.data.textbutton
							this.buttonurl = response.data.buttonurl
						}
					}else if(response.data.code == '200'){
						// this.servicio.precio = parseInt(response.data.masajeUno.valor + response.data.masajeDos.valor)
						this.servicio.terapistaUno = response.data.masajeUno.terapista
						this.servicio.masajeUnoValor = response.data.masajeUno.valor
						this.servicio.tarifaDinamicaUno = response.data.masajeUno.dinamica
                        // if(this.servicio.tarifaDinamicaUno > 0){
                        //     this.servicio.tarifaDinamicaUno = response.data.masajeUno.dinamica
                        //     this.servicio.precio += this.servicio.tarifaDinamicaUno
                        // }
						if(this.servicio.tipo != 'sencillo'){
							this.servicio.terapistaDos = response.data.masajeDos.terapista
							this.servicio.masajeDosValor = response.data.masajeDos.valor
                            this.servicio.tarifaDinamicaDos = response.data.masajeDos.dinamica
							// this.servicio.precio += this.servicio.tarifaDinamicaDos
						}
						if(this.servicio.grupal > 2){
							this.servicio.terapistaTres = response.data.masajeTres.terapista
							this.servicio.masajeTresValor = response.data.masajeTres.valor
                            this.servicio.tarifaDinamicaTres = response.data.masajeTres.dinamica
							// this.servicio.precio += response.data.masajeTres.valor + this.servicio.tarifaDinamicaTres
						}
						if(this.servicio.grupal > 3){
							this.servicio.terapistaCuatro = response.data.masajeCuatro.terapista
							this.servicio.masajeCuatroValor = response.data.masajeCuatro.valor
                            this.servicio.tarifaDinamicaCuatro = response.data.masajeCuatro.dinamica
							// this.servicio.precio += response.data.masajeCuatro.valor + this.servicio.tarifaDinamicaCuatro
						}
						if(this.servicio.grupal > 4){
							this.servicio.terapistaCinco = response.data.masajeCinco.terapista
							// this.servicio.precio += response.data.masajeCinco.valor
							this.servicio.masajeCincoValor = response.data.masajeCinco.valor
                            this.servicio.tarifaDinamicaCinco = response.data.masajeCinco.dinamica
							// this.servicio.precio += response.data.masajeCinco.valor + this.servicio.tarifaDinamicaCinco
						}
					}
					setTimeout(() => this.verificarProceso(), 2000)
				}).catch(error => {
					this.error = true
					this.errores = error.response.data
				})
			},
			verificarProceso(){
				// console.log('--- confirmando datos de servicio ---')
				// console.log(this.servicio.precio)
				if(this.servicio.tipo && this.servicio.fecha && this.servicio.hora && this.servicio.duracion && this.servicio.masaje_uno && this.servicio.terapistaUno && this.servicio.precio){
					if(this.servicio.tipo != 'sencillo'){
						if(this.servicio.terapistaDos && this.servicio.masaje_dos){
							this.confirmarProceso = true
						}
					}else{
						this.servicio.terapistaDos = ''
						this.servicio.masaje_dos = ''
						this.confirmarProceso = true
					}
				}else {
					this.confirmarProceso = false
				}
				// console.log(this.confirmarProceso)
			},
		},
		mounted() {
			// console.log('--- componente: selección fecha ---')
		}
	};

</script>